export const KsaHomeData = {
  ksaBanner: [
    {
      id: 1,
      backgroundImage: "/images/countries/riyadh/banner-1.avif",
      title: "The Best Development Company Awarded By ",
      awardLogo: "https://ik.imagekit.io/tlh8coiib/images/payoneer-circle.png",
      awardName: "Payoneer logo",
      heading: [
        { text: "Your Catalyst for Generative ", isSpan: false },
        { text: " AI Solutions", isSpan: true },
        { text: " & ", isSpan: false },
        { text: "Transformative Experiences", isSpan: true },
      ],
      subHeading:
        "From Generative AI development to AI chatbots & intelligent agents, we build scalable solutions that optimize operations & drive smarter business outcomes.",
      buttonText: "Build Your Legacy",
      buttonLink: "/contact-us",
    },
    // {
    //   id: 2,
    //   backgroundImage: "/images/countries/riyadh/banner-2.avif",
    //   title: "The Best Development Company Awarded By ",
    //   awardLogo: "https://ik.imagekit.io/tlh8coiib/images/payoneer-circle.png",
    //   awardName: "Payoneer logo",
    //   heading: [
    //     { text: "Empowering Innovation with Cutting-Edge ", isSpan: false },
    //     { text: "Blockchain", isSpan: true },
    //     { text: " ", isSpan: false },
    //     { text: "Services", isSpan: true },
    //   ],
    //   subHeading:
    //     "As a leading blockchain development company, we specialize in building custom blockchain solutions that maximize your IT investments, streamline operations, & enhance trust across your business ecosystem.",
    //   buttonText: "Start Your Blockchain Project",
    //   buttonLink: "/contact-us",
    // },
    {
      id: 3,
      backgroundImage: "/images/countries/riyadh/banner-3.avif",
      title: "The Best Development Company Awarded By",
      awardLogo: "https://ik.imagekit.io/tlh8coiib/images/payoneer-circle.png",
      awardName: "Clutch",
      heading: [
        { text: "Empowering Businesses with Innovative ", isSpan: false },
        // { text: "Cyber Security Solutions", isSpan: true },
        // { text: " & ", isSpan: false },
        // { text: "Seamless User Experiences", isSpan: true },
      ],
      subHeading:
        "We empower organizations with intelligent automation solutions that drive innovation, speed, and operational excellence.",
      buttonText: "Launch Your Custom Mobile App",
      buttonLink: "/contact-us",
    },
    {
      id: 4,
      backgroundImage: "/images/countries/riyadh/banner-4.avif",
      title: "The Best Development Company Awarded By",
      awardLogo: "https://ik.imagekit.io/tlh8coiib/images/payoneer-circle.png",
      awardName: "Clutch",
      heading: [
        { text: "Transforming Ideas into Cutting-Edge ", isSpan: false },
        { text: "Custom Development", isSpan: true },
        { text: " & ", isSpan: false },
        { text: "Exceptional User Experiences", isSpan: true },
      ],
      subHeading:
        "Our software consulting services guide businesses in strategy, planning, & execution of custom software development projects to ensure technology investments deliver maximum business impact.",
      buttonText: "Schedule Your Consultation",
      buttonLink: "/contact-us",
    },
  ],
  sectionsButton: [
    // { id: 5, heading: "Hire AI Agents" },
    { id: 6, heading: "AI Solutions" },
    { id: 1, heading: "Bots & AI Agents" },
    // { id: 2, heading: "Blockchain & Web3 Solutions" },
    { id: 3, heading: "Business Intelligent Automation" },
    // { id: 4, heading: "Custom Software Platforms" },
  ],
  ksaScrollerData: [
    {
      text: "Recognition",
      link: "testimonial-section",
    },
    {
      text: "Hire Us",
      link: "hire-us",
    },
    {
      text: "Why Us",
      link: "why-us",
    },
    {
      text: "Our Stacks ",
      link: "our-stacks",
    },
    {
      text: "IT Services",
      link: "it-services",
    },
    {
      text: "Models",
      link: "engagment-models",
    },
    {
      text: "Industries ",
      link: "pioner-change-box",
    },
    {
      text: "Our Core Team",
      link: "our-team",
    },
    {
      text: "Insights",
      link: "trends",
    },
    {
      text: "Locations",
      link: "our-locations",
    },
  ],
  hireForUs: {
    slides: [
      {
        id: 1,
        icon: "/images/icon1.svg",
        heading: "AI development",
        text: "We help you leverage advanced AI technologies like LLMs, chatbots, & NLP to automate processes & gain insightful, data-driven decisions tailored to your business needs.",
        btnLink: "contact-us",
      },
      {
        id: 3,
        icon: "/images/machine-learning.png",
        heading: "Custom software development",
        text: "Need tailored solutions? Our custom software development transforms your vision into reality, optimizing efficiency & innovation.",
        btnLink: "contact-us",
      },
      // {
      //   id: 4,
      //   icon: "/images/icon3.svg",
      //   heading: "Data analytics",
      //   text: "Unlock the power of data with AI-driven analytics, BI insights, & predictive models to fuel data-driven decision-making.",
      //   btnLink: "contact-us",
      // },
      {
        id: 7,
        icon: "/images/cloud.png",
        heading: "Cloud Solutions",
        text: "Supercharge your cloud infrastructure with expert DevOps services on AWS, GCP, & Azure—ensuring scalability, security, & peak efficiency.",
        btnLink: "contact-us",
      },
      {
        id: 8,
        icon: "/images/web-programming.png",
        heading: "Web app development",
        text: "Empower your digital presence with scalable, high-performance web apps designed for seamless user engagement & business growth",
        btnLink: "contact-us",
      },
      {
        id: 9,
        icon: "/images/mobile-development.png",
        heading: "Software development",
        text: "Transform ideas into powerful, high-speed mobile apps with cutting-edge native, hybrid, & cross-platform solutions for iOS & android.",
        btnLink: "contact-us",
      },
      {
        id: 6,
        icon: "/images/dekstop-icon.svg",
        heading: "Desktop app development",
        text: "Enhance productivity with custom-built, secure, & high-performance desktop apps tailored to your unique business needs.",
        btnLink: "contact-us",
      },
      {
        id: 10,
        icon: "/images/software-testing.png",
        heading: "QA & Software Testing",
        text: "Ensure flawless software with comprehensive QA services, manual testing, & automated solutions for seamless performance.",
        btnLink: "contact-us",
      },
      {
        id: 11,
        icon: "/images/video-marketing.png",
        heading: "Digital Branding & Growth",
        text: "Amplify your brand’s online presence with data-driven digital branding strategies to boost engagement & build lasting customer connections.",
        btnLink: "contact-us",
      },
      // {
      //   id: 12,
      //   icon: "/images/high-values-icons/robust-architecture.svg",
      //   heading: "Cyber Security",
      //   text: "Protecting your digital assets with comprehensive security solutions against evolving threats.",
      //   btnLink: "contact-us",
      // },
    ],
    heading: "Hire us for Full-Spectrum Tech Services That Drive Results",
    contentArray: [
      "Whether you need custom software, strategic IT consulting, advanced AI, or solid cybersecurity right here in the United States, we’ve got you covered.",
    ],
    iamLookingForButton: "I’m looking for",
    sidebar: {
      heading:
        "Starting Price That Fits Your Budget/ Top-Tier Expertise, Cost-Effective Plans",
      subHeading:
        "High-Impact Solutions at a Budget-Friendly Price/ Premium Solutions, Affordable Pricing",
      paragraphOne:
        "Scaling your business with top-tier software development, consulting, & digital branding doesn’t have to break the bank. We provide cutting-edge solutions tailored to your needs, ensuring seamless performance, security, & innovation—all at an affordable rate.",
      paragraphTwo:
        "Starting at just $24 per hour, our expert team guarantees high-quality services that drive efficiency & growth. Whether you're launching a new product, optimizing your operations, or strengthening your online presence, we deliver measurable results that maximize your investment.",
      letsBuildButton: "Let’s Build Something Great",
    },
  },
  whyUs: {
    greenHeading: "The Strategic",
    heading: " Advantage of Partnering With Us",
    description:
      "Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth.",
    statsData: [
      // {
      //   number: "2017",
      //   title: "Delivering Excellence Since",
      // },
      {
        number: "120+",
        title: "Successful Projects Delivered",
      },
      {
        number: "100+",
        title: "Associated Professionals",
      },
      // {
      //   number: "20+",
      //   title: "Solutions Across Industries",
      // },
    ],
    cta: { text: "Contact Us", link: "/contact-us" }
  },
  servicesInsights: {
    // heading: "Enterprise Service Insights",
    heading: "Engineering the Future With <br/> AI & Custom Software",
    description:
      "Whether you need custom software, strategic IT consulting, advanced AI, or solid cybersecurity right here in the United States, we’ve got you covered. ",
    topBox: [
      {
        id: 1,
        title: "AI Automation for Business Growth",
        description: "We design and deploy automation that removes repetitive work from your team's day  lead routing, reporting, follow-ups  using workflow automation, AI-driven decision logic, and integrations built to hold up in production.",
        linkText: "Learn More",
        linkURL: "artificial-intelligence-development-services",
        bgImg: "/images/enterprise-services/ai-services.avif",
        icon: "/images/home-page-icons/AI-Services.svg",
        altText: "AI and machine learning solutions for business growth",
        link: "/ai-ml-development-services"
      },
      {
        id: 6,
        title: "Intelligent Automation for Business Processes",
        description: "We help organizations automate and optimize business processes using intelligent automation. By combining workflow automation, AI-driven decision support, and system integrations, we reduce manual effort, improve operational efficiency, and enable teams to scale without increasing overhead.",
        linkText: "Learn More",
        linkURL: "custom-software-development-services",
        bgImg: "/images/enterprise-services/software-development.avif",
        icon: "/images/home-page-icons/automation-home-page-icon.png",
        altText: "Intelligent automation for streamlined business processes",
        link: "/custom-software-development-services"
      },
      {
        id: 3,
        title: "AI Clarity & Consultancy",
        description: "Most businesses don't have an AI problem  they have an AI confusion problem. Our AI Clarity audit maps your workflows, flags where automation pays off first, and hands you a prioritized roadmap, not a slide deck of buzzwords.",
        linkText: "Learn More",
        linkURL: "dev-ops-services",
        bgImg: "/images/enterprise-services/devops-services.avif",
        icon: "/images/home-page-icons/DevOps-Services.svg",
        altText: "End to end DevOps services for scalable and secure systems",
        link: "/dev-ops-services"
      },
      // {
      //   id: 4,
      //   title: "Next-Gen Mobile App Development",
      //   description: "Bitsclan is a premier mobile app development company in the USA specializing in high-end custom web app development & enterprise mobile app development services. Our experienced team creates innovative, scalable, & secure apps for your business needs.",
      //   linkText: "Learn More",
      //   linkURL: "mobile-app-development-services",
      //   bgImg: "/images/enterprise-services/mobile-app-development.avif",
      //   icon: "/images/home-page-icons/Mobile-app-development.svg",
      //   link: "/mobile-app-development-services"
      // },
      {
        id: 5,
        title: "Custom Software Solutions Tailored to You",
        description: "Bitsclan's custom software development services help businesses design & implement tailored solutions. With our expertise in scalability, innovation, & efficiency, we ensure technology investments drive measurable results & deliver long-term business value.",
        linkText: "Learn More",
        linkURL: "custom-software-development-services",
        bgImg: "/images/enterprise-services/software-development.avif",
        icon: "/images/home-page-icons/custom-software-home-page-icon.png",
        altText: "Custom software solutions tailored to business needs",
        link: "/custom-software-development-services"
      },
      // {
      //   id: 7,
      //   title: "Bots & AI Agents for Operational Efficiency",
      //   description: "We design and deploy AI agents that automate routine tasks, assist teams in real time, and connect systems across the business. From data handling and customer interactions to internal workflows, our automation agents reduce manual effort, improve response times, and support consistent, scalable operations.",
      //   linkText: "Learn More",
      //   linkURL: "custom-software-development-services",
      //   bgImg: "/images/enterprise-services/software-development.avif",
      //   icon: "/images/home-page-icons/ai-agents-home-page-icon.png",
      //   altText: "Bots and AI agents for improved operational efficiency",
      //   link: "/custom-software-development-services"
      // },
    ],
    cta: {
      text: "Start With an AI Clarity Call",
      link: "/contact-us",
    }
  },
  pioneeringChange: {
    heading: "Pioneering Change",
    greenHeading: "Across Industries",
    description:
      "Our AI & IT services & solutions create long lasting competitive advantages & support diverse use cases across all major industries.",
    learnMoreLeft: "Learn more about our",
    learnMoreRight: "industry",
  },
  ourTeam: {
    heading: "Meet the Experts Driving Enterprise Transformation",
    subHeading:
      "Our dedicated team shares expert insights on emerging technologies & industry trends. From AI solutions to software engineering & custom app development, we deliver strategies that help businesses innovate, scale, & stay ahead.",
    team: [
      {
        name: "Awais Sarwar",
        location: "USA",
        designation: "Chief Executive Officer",
        image: "/images/life-at-bitsclan/awais.avif",
      },
      {
        name: "Haider Javed",
        location: "USA",
        designation: "Chief Technology Officer",
        image: "/images/life-at-bitsclan/haider.avif",
      },
      {
        name: "Kevin Houston",
        location: "USA",
        designation: "Director of Advisory & Partnerships",
        image: "/images/life-at-bitsclan/kevin.avif",
      },
      {
        name: "Aamanda Hawkins",
        location: "Canada",
        designation: "Marketing Consultant",
        image: "/images/life-at-bitsclan/aamanda.avif",
      },
      // {
      //   name: "Andreea Ray",
      //   location: "USA",
      //   designation: "Client Success Manager",
      //   image: "/images/life-at-bitsclan/andreea.avif",
      // },
      {
        name: "Dusty Mclean",
        location: "Mississippi, United States",
        designation: "Senior eCommerce Marketing Consultant",
        image: "/images/life-at-bitsclan/dusty.avif",
      },
      {
        name: "Omoniyi Awofesobi",
        location: "USA",
        designation: "Director of Advisory & Partnerships",
        image: "/images/life-at-bitsclan/omoniyi.avif",
      },
      {
        name: "Shams Shammasi",
        location: "KSA",
        designation: "Managing Partner",
        image: "/images/life-at-bitsclan/shams.avif",
      },
      {
        name: "Suheb Ahmed",
        location: "AUS",
        designation: "Financial Crime & Data Analytics",
        image: "/images/life-at-bitsclan/suhab.avif",
      },
    ],
  },
  ourLocations: {
    heading: "Our Locations",
    locations: [
      {
        title: "Head Office",
        location: "New York",
        address: "2 Park Ave 20th floor, New York, NY 10016",
        addressLink: "https://maps.app.goo.gl/KLGhpKxNaL9qhyXq8",
        icon: "new-york.svg",
        altText: "Bitsclan Head Office New York City Headquarters",
      },
      {
        title: "Europe Office",
        location: "Sweden",
        address: "Barometergatan 16, 418 41 Göteborg, Sweden",
        addressLink: "https://maps.app.goo.gl/ujNgkiwdasgdErus5",
        icon: "Sweden.svg",
        altText: "Bitsclan Europe Office Sweden City Landmark",
      },
      {
        title: "Gulf Office",
        location: "KSA",
        address:
          "Building 26/27 - 120 A Support Industries, Jubail Industry City, Saudi Arabia",
        icon: "Qatar.svg",
        altText: "Bitsclan Gulf Office Saudi Arabia Jubail City",
      },
      {
        title: "Australia Office",
        location: "Queensland",
        address: "40 Saintly Road Logan Reserve Queensland Australia",
        icon: "Australia.svg",
        altText: "Bitsclan Australia Office Queensland City"
      },
    ],
  },
  tabsData: {
    tabs: [
      "AI",
      "Blockchain",
      // "Cyber Security",
      "Database",
      "Backend",
      "Frontend",
      "Mobile",
      "Frameworks",
      "Cloud",
      "DevOps",
      "Ecommerce",
      "Platforms",
    ],
    tabItems: [
      {
        tab: "AI",
        icon: "/images/genai1.svg",
        name: "CycleGAN",
      },
      {
        tab: "AI",
        icon: "/images/genai2.svg",
        name: "DeepArt",
      },
      {
        tab: "AI",
        icon: "/images/genai3.svg",
        name: "DeepDream",
      },
      { tab: "AI", icon: "/images/genai4.svg", name: "VQ-VAE" },
      { tab: "AI", icon: "/images/genai5.svg", name: "GPT-4" },
      { tab: "AI", icon: "/images/genai6.svg", name: "GPT-3" },
      { tab: "AI", icon: "/images/genai6.svg", name: "DALL-E" },
      { tab: "AI", icon: "/images/genai6.svg", name: "OpenAI GPT" },
      {
        tab: "AI",
        icon: "/images/genai6.svg",
        name: "OpenAI DALL-E",
      },
      {
        tab: "AI",
        icon: "/images/module1.svg",
        name: "DeepMind Sonnet",
      },
      {
        tab: "AI",
        icon: "/images/module2.svg",
        name: "Facebook AI Research ",
      },
      {
        tab: "AI",
        icon: "/images/module3.svg",
        name: "Hugging Face",
      },
      {
        tab: "AI",
        icon: "/images/module4.svg",
        name: "NVIDIA StyleGAN",
      },
      {
        tab: "AI",
        icon: "/images/tech-icon.svg",
        name: "PyTorch",
      },
      {
        tab: "AI",
        icon: "/images/tech-icon2.svg",
        name: "Keras",
      },
      {
        tab: "AI",
        icon: "/images/tech-icon3.svg",
        name: "MXNet",
      },
      {
        tab: "AI",
        icon: "/images/tech-icon4.svg",
        name: "TensorFlow",
      },
      {
        tab: "AI",
        icon: "/images/tech-icon5.svg",
        name: "Caffe",
      },
      { tab: "AI", icon: "/images/natural1.svg", name: "RBM" },
      { tab: "AI", icon: "/images/natural2.svg", name: "DBN" },
      {
        tab: "AI",
        icon: "/images/natural7.svg",
        name: "Transformers",
      },
      {
        tab: "AI",
        icon: "/images/natural4.svg",
        name: "Autoencoders",
      },
      { tab: "AI", icon: "/images/natural5.svg", name: "DRLN" },
      { tab: "AI", icon: "/images/natural6.svg", name: "GAN" },
      { tab: "AI", icon: "/images/tech-icon.svg", name: "PyTorch" },
      { tab: "AI", icon: "/images/tech-icon2.svg", name: "Keras" },
      { tab: "AI", icon: "/images/tech-icon3.svg", name: "MXNet" },
      { tab: "AI", icon: "/images/libraries1.svg", name: "FastAI" },
      { tab: "AI", icon: "/images/libraries2.svg", name: "TensorFlow" },
      { tab: "AI", icon: "/images/libraries3.svg", name: "Theano" },
      { tab: "AI", icon: "/images/libraries4.svg", name: "Scikit-learn" },
      {
        tab: "AI",
        icon: "/images/calsification.svg",
        name: "AlexNet",
      },
      {
        tab: "AI",
        icon: "/images/calsification2.svg",
        name: "EfficientNet",
      },
      {
        tab: "AI",
        icon: "/images/calsification3.svg",
        name: "Xception",
      },
      {
        tab: "AI",
        icon: "/images/calsification4.svg",
        name: "DenseNet",
      },
      {
        tab: "AI",
        icon: "/images/calsification5.svg",
        name: "Inception",
      },
      {
        tab: "AI",
        icon: "/images/calsification6.svg",
        name: "ResNet",
      },
      {
        tab: "AI",
        icon: "/images/calsification7.svg",
        name: "VGGNet",
      },
      // CYBER SECURITY ICONS
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/burp-suite.png",
        name: "Brup Suite",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/check-point.png",
        name: "Check Point",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/cisco-secures.png",
        name: "Ciso Secures",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/crowd-strike.png",
        name: "Crowd Strike",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/dark-trace.png",
        name: "Dark Trace",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/fortinet.png",
        name: "Fortinet",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/kali.png",
        name: "Kali",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/metasploit.png",
        name: "Metasploit",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/nessus.png",
        name: "Nessus",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/qradar-logo.png",
        name: "IBM Radar",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/qualys.png",
        name: "Qualys",
      },

      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/snort.png",
        name: "Snort",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/splunk.png",
        name: "Splunk",
      },
      {
        tab: "Cyber Security",
        icon: "/images/tech-stack-icons/wire-shark.png",
        name: "Wire Shark",
      },
      // Blockchain Platforms
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/ethereum.png",
        name: "Ethereum",
      },
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/stellar.png",
        name: "Stellar",
      },
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/Ripple.png",
        name: "Ripple",
      },

      // Enterprise Solutions
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/Hyperledger.png",
        name: "HyperLedger",
      },
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/microsoft-icon.png",
        name: "Azure Blockchain",
      },
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/download-3.png",
        name: "Azure Service Fabric",
      },

      // Consensus Mechanisms
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/tendermint-logo-black.png",
        name: "Tendermint",
      },

      // Storage Solutions
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/IPFS_logo.png",
        name: "IPFS",
      },
      {
        tab: "Blockchain",
        icon: "/images/tech-stack-icons/Bigchaindb.png",
        name: "BigChainDB",
      },
      { tab: "Frontend", icon: "/images/iconone.png", name: "Angular JS" },
      { tab: "Frontend", icon: "/images/icontwo.png", name: "JavaScript" },
      { tab: "Frontend", icon: "/images/iconthree.png", name: "React JS" },
      { tab: "Frontend", icon: "/images/icon4.png", name: "Vue JS" },
      { tab: "Frontend", icon: "/images/icon5.png", name: "Tez JS" },
      { tab: "Frontend", icon: "/images/icon6.png", name: "CSS3" },
      { tab: "Frontend", icon: "/images/icon7.png", name: "HTML5" },
      { tab: "Backend", icon: "/images/database1.png", name: ".Net" },
      { tab: "Backend", icon: "/images/database2.png", name: "Nest Js" },
      { tab: "Backend", icon: "/images/database3.png", name: "Meteor JS" },
      { tab: "Backend", icon: "/images/database4.png", name: "Fastify" },
      { tab: "Backend", icon: "/images/database5.png", name: "Express JS" },
      { tab: "Backend", icon: "/images/database6.png", name: "Python" },
      { tab: "Backend", icon: "/images/database7.png", name: "Java" },
      { tab: "Backend", icon: "/images/database8.png", name: "PHP" },
      { tab: "Backend", icon: "/images/database9.png", name: "Node Js" },
      { tab: "Mobile", icon: "/images/mobile1.png", name: "Android" },
      { tab: "Mobile", icon: "/images/mobile2.png", name: "IOS" },
      { tab: "Mobile", icon: "/images/mobile3.png", name: "Swift" },
      { tab: "Mobile", icon: "/images/mobile4.png", name: "Flutter" },
      { tab: "Mobile", icon: "/images/mobile5.png", name: "Xamarin" },
      { tab: "Mobile", icon: "/images/mobile6.png", name: "React Native" },
      { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
      { tab: "Database", icon: "/images/db2.png", name: "Oracle " },
      { tab: "Database", icon: "/images/db3.png", name: "MongoDB" },
      {
        tab: "Database",
        icon: "/images/tech-stack-icons/postgres.svg",
        name: "PostgreSQL",
      },
      { tab: "Database", icon: "/images/db5.png", name: "MySQL" },
      { tab: "Database", icon: "/images/db6.png", name: "SQL Server" },
      { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
      { tab: "Database", icon: "/images/db8.png", name: "DynamoDB" },
      { tab: "Frameworks", icon: "/images/framework6.png", name: "Django" },
      {
        tab: "Frameworks",
        icon: "/images/framework2.png",
        name: "CodeIgniter",
      },
      { tab: "Frameworks", icon: "/images/framework3.png", name: "Laravel" },
      { tab: "Frameworks", icon: "/images/framework1.png", name: "MEAN" },
      { tab: "Frameworks", icon: "/images/framework4.png", name: "Rxweb.io" },
      { tab: "Frameworks", icon: "/images/framework5.png", name: "CakePHP" },
      { tab: "Cloud", icon: "/images/cloud1.png", name: "Google Cloud" },
      { tab: "Cloud", icon: "/images/cloud2.png", name: "Azure" },
      { tab: "Cloud", icon: "/images/cloud3.png", name: "AWS" },
      { tab: "Cloud", icon: "/images/DigitalOcean.png", name: "Digital Ocean" },
      { tab: "DevOps", icon: "/images/devops1.png", name: "Gradle" },
      { tab: "DevOps", icon: "/images/devops2.png", name: "Kubernetes" },
      { tab: "DevOps", icon: "/images/devops3.png", name: "Docker" },
      { tab: "DevOps", icon: "/images/devops4.png", name: "Jenkins" },
      {
        tab: "DevOps",
        icon: "/images/openshift-svgrepo-com.svg",
        name: "Open Shift",
      },
      { tab: "DevOps", icon: "/images/packer-svgrepo-com.svg", name: "Packer" },
      {
        tab: "DevOps",
        icon: "/images/ansible-svgrepo-com.svg",
        name: "Ansible",
      },
      {
        tab: "DevOps",
        icon: "/images/saltstack-svgrepo-com.svg",
        name: "Salt Stack",
      },
      { tab: "Ecommerce", icon: "/images/ecomres1.png", name: "NopCommerce" },
      { tab: "Ecommerce", icon: "/images/ecomres2.png", name: "Kentico" },
      { tab: "Ecommerce", icon: "/images/ecomres3.png", name: "Shopify" },
      { tab: "Ecommerce", icon: "/images/ecomres4.png", name: "Magento" },
      { tab: "Ecommerce", icon: "/images/ecomres5.png", name: "WooCommerce" },
      { tab: "Platforms", icon: "/images/platform1.png", name: "Servicenow " },
      { tab: "Platforms", icon: "/images/platform2.png", name: "Tableau" },
      {
        tab: "Platforms",
        icon: "/images/platform3.png",
        name: "MS Dynamics CRM",
      },
      { tab: "Platforms", icon: "/images/platform4.png", name: "Zoho" },
      { tab: "Platforms", icon: "/images/platform5.png", name: "Power BI" },
      { tab: "Platforms", icon: "/images/platform6.png", name: "Salesforce " },
    ],
    default: "Frontend",
    heading: "Don't worry! We've got the tech stacks you're looking for!",
    subHeading:
      "We have experts in almost all major & common tech stacks. Our team is rapidly expanding, covering more programming languages & expertise. You can be confident you'll get the experts you need when you work with us.",
  },
  caseStudiesSection: {
    shortHeading: "Our Success Stories",
    mainHeading: "Trusted by the World's Leading Companies",
    description: "Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries.",
    cta: {
      text: "View All Success Stories",
      link: "/case-studies"
    }
  }
};
